export default __webpack_public_path__ + "static/media/dulces_detail6.0b71c267.jpg";